// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4h-0";
export var eligibilityCardNotEligible = "_4h-1";